import styled from 'styled-components';
import {useCustomTheme} from 'context/customTheme';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {Loader} from '@guestapp/old-ui-kit';

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ViewLoader = () => {
  const {finalTheme} = useCustomTheme();
  const {colors} = finalTheme;
  const layoutMode = useLayoutMode();
  const loaderSize = layoutMode === 'kiosko' ? 140 : 60;

  return (
    <LoadingWrapper>
      <Loader color={colors.branding.primary} width={loaderSize} height={loaderSize} />
    </LoadingWrapper>
  );
};
